// Restaurant-local clock (Europe/Belgrade canonical for Ponesi Serbia). The tablet's own timezone
// is never used for scheduling maths — a device set to UTC must still schedule in restaurant time.
const TZ = "Europe/Belgrade";

const parts = (d) => {
  const f = new Intl.DateTimeFormat("en-GB", {
    timeZone: TZ, hour: "2-digit", minute: "2-digit", hour12: false,
  }).formatToParts(d);
  return Object.fromEntries(f.map((p) => [p.type, p.value]));
};

/** "HH:MM" in restaurant-local time for any Date / ms / ISO string. */
export function localHHMM(value) {
  const d = value instanceof Date ? value : new Date(value);
  if (isNaN(d)) return "";
  const p = parts(d);
  return `${p.hour === "24" ? "00" : p.hour}:${p.minute}`;
}

/** Minutes elapsed since restaurant-local midnight — used to compare clock times safely. */
export function localMinutesOfDay(value = new Date()) {
  const hm = localHHMM(value);
  if (!hm) return null;
  const [h, m] = hm.split(":").map(Number);
  return h * 60 + m;
}

/** HH:MM shifted by `delta` minutes inside the same restaurant-local day (clamped, no wrap). */
export function shiftHHMM(hhmm, delta) {
  if (!/^\d{2}:\d{2}$/.test(hhmm || "")) return "";
  const [h, m] = hhmm.split(":").map(Number);
  const total = Math.min(23 * 60 + 59, Math.max(0, h * 60 + m + delta));
  return `${String(Math.floor(total / 60)).padStart(2, "0")}:${String(total % 60).padStart(2, "0")}`;
}
